export const BUTTON_SHAPE_TYPES = {
	ROUNDED: 'rounded',
	SQUARED: 'squared',
};

export const DEFAULT_NAV_TIMEOUT = 1; // 1 second
